export const pColor = "#4c94b6";
export const sColor = "#6aa7f8";
export const tColor = "#1a73e8";

// Letters
export const pLetterColor = "#fff";